import Vue from "vue";
import Router from "vue-router";
import { middlewares } from "./middlewares";
// routes
import login from "./login";
import recover from "./recover-password";
import syncdatetime from "./syncdatetime";
import formtrackerinstallation from "./form-tracker-installation";
import formtrackerremove from "./form-tracker-remove";
import formacessoriesinstallation from "./form-acessories-installation";
import formregistervehiclesoftware from "./form-register-vehicle-software";
import main from "./main";

Vue.use(Router);

const router = new Router({
  routes: [
    login,
    recover,
    syncdatetime,
    formtrackerinstallation,
    formtrackerremove,
    formacessoriesinstallation,
    formregistervehiclesoftware,
    main,
  ],
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

middlewares(router);

export default router;
